module.exports = __webpack_public_path__ + "img/color.283f42c7.svg";